<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <div>
          <div class="mb-0"><label class="v-label v-label--active theme--light body-2">Type:</label></div>
          <v-btn-toggle
            v-model="stats.type"
            mandatory
            borderless
          >
            <v-btn
              small
              value="day"
              :color="stats.current_type == 'day' ? 'primary' : null"
            >
              Day
            </v-btn>
            <v-btn
              small
              value="game"
              :color="stats.current_type == 'game' ? 'primary' : null"
            >
              Game
            </v-btn>

            <v-btn
              small
              value="game_session"
              :color="stats.current_type == 'game_session' ? 'primary' : null"
            >
              Game Session
            </v-btn>

            <v-btn
              small
              value="login_session"
              :color="stats.current_type == 'login_session' ? 'primary' : null"
            >
              Login Session
            </v-btn>

            <v-btn
              small
              value="loyalty"
              :color="stats.current_type == 'loyalty' ? 'primary' : null"
            >
              Loyalty
            </v-btn>
            <v-btn
              small
              value="safebox"
              :color="stats.current_type == 'safebox' ? 'primary' : null"
            >Safebox</v-btn>
            <v-btn
              small
              value="extra_purchase"
              :color="stats.current_type == 'extra_purchase' ? 'primary' : null"
            >Extra Purchase</v-btn>
          </v-btn-toggle>
        </div>

        <v-select
          v-model="dateRange"
          :items="dateRangeList"
          v-on:change="changeTimePeriod"
          label="Period"
          hide-details
          class="col-1"
          style="min-width: 180px"
        ></v-select>
        <date-picker
          v-model="stats.from"
          label="Date From"
          style="max-width: 150px"
        />

        <date-picker
          v-model="stats.to"
          label="Date To"
          style="max-width: 150px"
        />

        <v-btn color="info" v-on:click="search" class="mt-3">Search</v-btn>
      </v-row>
    </v-card>


    <v-card class="pa-4 mt-4">
      <v-data-table
        :loading="stats.loading"
        :headers="headers"
        :items="filteredTransactions"
        sort-by="created"
        sort-desc
        fixed-header
        hide-default-footer
        :items-per-page="-1"
        dense
        calculate-widths
        class="account-statistic-table"
        style="z-index: 0; position: relative; white-space: nowrap"
      >
        <template v-slot:body.prepend>
          <tr class="grey lighten-3" v-if="showFilters">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="stats.filters.hasOwnProperty(header.value) && stats.filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-bonus-filter-select"
                :items="columnValueList(header.value)"
                v-model="stats.filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-bonus-filter-textfield mx-auto"
                v-if="stats.filters.hasOwnProperty(header.value) && stats.filters[header.value].type == 'text'"
                v-model="stats.filters[header.value].data"
                hide-details
                :style="stats.filters[header.value].style"
              ></v-text-field>
            </td>
          </tr>
        </template>

        <template v-slot:item.log="{ item }">
          <v-btn
            v-if="!!item.log.req_params"
            icon
            @click="showLog = true; log = item.log"
          >
            <v-icon>mdi-folder-information-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.safebox_type="{item}">
          <template v-if="item.type === 'deposit'">
            deposit (safebox -> balance)
          </template>
          <template v-else>
            withdraw (balance -> safebox)
          </template>
        </template>

        <template v-slot:body.append>
          <total-calculate-rows
            v-if="totalByFiltredRows"
            :row-data="totalByFiltredRows"
            :headers="headers"
            :options="options"
          />
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="showLog"
      width="70%"
      content-class="game-session-request-log"
    >
      <v-card v-if="log">
        <v-card-title class="text-h5 grey lighten-2">
          Game Session Log {{ log.status }} | {{ log.error }}
          <v-spacer />
          <v-btn
            icon
            style="margin-right: -10px"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container style="height: 80vh;display: flex;flex-direction: column;" class="pa-0 ma-0">
            <h3 class="py-2">Request:</h3>

            <pre style="overflow-y: auto; white-space: pre-wrap" class="mb-2" contenteditable>{{ log.req_params }}</pre>

            <v-divider />
            <h3 class="py-2">Response:</h3>

            <pre style="overflow-y: auto; white-space: pre-wrap" contenteditable>{{ log.res_data }}</pre>

          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<style>
  .data-table-bonus-filter-select .v-select__selections {
    height: 32px;
    overflow: hidden;
    white-space: nowrap;
  }

  .data-table-bonus-filter-select {
    max-width: 150px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .data-table-bonus-filter-textfield input {
  }

  .data-table-bonus-filter-textfield {
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .game-session-request-log {
    max-height: none !important;
  }

</style>

<script>

  import { toArray } from 'lodash'
  import { mapGetters } from 'vuex'
  import { totalTableMixin } from '@/components/report/TotalRows/TotalTableMixin'
  import TotalCalculateRows from '@/components/report/TotalRows/TotalCalculateRows.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'
  import { makeDateRangeComputed } from '../utils'

  export default {

    props: [],
    mixins: [totalTableMixin],
    components: {
      TotalCalculateRows,
      DatePicker
    },
    data: () => ({
      showLog: null,
      log: null,

      statuses: [
        { text: 'New', value: 'new' },
        { text: 'Active', value: 'active' },
        { text: 'Canceled', value: 'canceled' },
        { text: 'Released', value: 'released' },
        { text: 'Used', value: 'used' },
        { text: 'Expired', value: 'expired' },
        { text: 'Error', value: 'error' },
      ],
      dateRangeList,
      // headers: [],
      headersByType: {
        game_session: [
          { text: 'SessionID', value: 'session_id' },
          { text: 'Game', value: 'game_name' },
          { text: 'SG ID', value: 'softgame_id' },
          { text: 'Start', value: 'session_start' },
          { text: 'End', value: 'session_end', },
          { text: 'Bet', value: 'bet' },
          { text: 'Win', value: 'win' },
          { text: 'GGR', value: 'ggr' },
          { text: 'Status', value: 'status' },
          { text: '', value: 'log' },
        ],
        login_session: [
          { text: 'SessionID', value: 'session_id' },
          { text: 'Start', value: 'session_start' },
          { text: 'End', value: 'session_end', },
          { text: 'Bet', value: 'bet' },
          { text: 'Win', value: 'win' },
          { text: 'GGR', value: 'ggr' },
        ],
        day: [
          { text: 'Day', value: 'day' },
          { text: 'Deposit', value: 'deposit' },
          { text: 'Withdraw', value: 'withdraw' },
          { text: 'Bonus', value: 'bonus_deposit' },
          { text: 'Bet', value: 'bet' },
          { text: 'Win', value: 'win' },
          { text: 'Balance Bet', value: 'balance_bet' },
          { text: 'Balance Win', value: 'balance_win' },
          { text: 'Bonus Bet', value: 'bonus_bet' },
          { text: 'Bonus Win', value: 'bonus_win' },
          { text: 'Balance GGR', value: 'balance_ggr' },
          { text: 'Bonus GGR', value: 'bonus_ggr' },
          { text: 'GGR', value: 'ggr' },
          { text: 'NGR', value: 'ngr' },
          { text: 'Cash bonus', value: 'cash_bonus' },
          { text: 'Extra Purchases', value: 'extra_purchases' },
        ],
        game: [
          { text: 'Game', value: 'game_name' },
          { text: 'Provider', value: 'system' },
          { text: 'Brand', value: 'brand' },
          { text: 'Bet', value: 'bet' },
          { text: 'Win', value: 'win' },
          { text: 'Balance Bet', value: 'balance_bet' },
          { text: 'Balance Win', value: 'balance_win' },
          { text: 'Bonus Bet', value: 'bonus_bet' },
          { text: 'Bonus Win', value: 'bonus_win' },
          { text: 'Balance GGR', value: 'balance_ggr' },
          { text: 'Bonus GGR', value: 'bonus_ggr' },
          { text: 'GGR', value: 'ggr' },
        ],
        loyalty: [
          { text: 'Type', value: 'type' },
          { text: 'Loyalty', value: 'loyalty_points' },
          { text: 'Loyalty balance', value: 'loyalty_points_balance' },
          { text: 'Source', value: 'source' },
          { text: 'Description', value: 'description' },
          { text: 'Created', value: 'created' },
        ],
        safebox: [
          { text: 'Created', value: 'created' },
          { text: 'ID', value: 'account_transaction_id' },
          { text: 'Debit', value: 'debit' },
          { text: 'Credit', value: 'credit' },
          { text: 'Type', value: 'safebox_type' },
        ],
        extra_purchase: [
          { text: 'Tr ID', value: 'account_transaction_id', },
          { text: 'Currency', value: 'currency', },
          { text: 'Amount', value: 'amount', },
          { text: 'Amount (EUR)', value: 'amount_eur', },
          { text: 'Completed', value: 'completed', },
          { text: 'Benefit', value: 'benefit' },
          { text: 'Package ID', value: 'package_id' },
        ],
      },
      options: {
        totalCalculate: {
          fields: [
            'bet', 'win', 'ggr', 'deposit',
            'withdraw', 'bonus_deposit', 'balance_bet',
            'balance_win', 'balance_ggr', 'ngr',
            'cash_bonus', 'bonus_bet', 'bonus_win',
            'bonus_ggr', 'amount'
          ],
          titleField: 'day',
        },
      },
    }),

    mounted () {
      this.stats.current_type = this.stats.type
    },

    computed: {
      showFilters: function () {
        return toArray(this.stats.filters).length > 0
      },
      headers: function () {
        return this.headersByType[this.stats.current_type] || []
      },
      ...mapGetters({ activeAccount: 'account/active', stats: 'account/stats' }),
      filteredTransactions: function () {
        return this.stats.items.filter(d => {
          return Object.keys(this.stats.filters).every(f => {
            return this.stats.filters[f].data.length < 1 || (this.stats.filters[f].data.includes(d[f]) || (d[f] || '').toString().indexOf(this.stats[f].data) >= 0)
          })
        })
      },

      filteredItems() {
        return this.filteredTransactions
      },

      dateRange: makeDateRangeComputed('stats'),
    },

    methods: {

      changeTimePeriod: function (value) {
        this.stats.from = value.from
        this.stats.to = value.to
      },

      search: function () {
        this.$store.dispatch('account/loadStats', this.activeAccount.account)
        .then(() => {
          this.$set(this.options.totalCalculate, 'titleField', this.getLastNonTotalableField())
        }).catch(e => {
          this.$showError(e.response.data.message)
        })
      },

      getLastNonTotalableField() {
        let fieldKey = this.headers[0].value
        for (const header of this.headers) {
          if (this.options.totalCalculate.fields.includes(header.value)) {
            return fieldKey
          }

          fieldKey = header.value
        }
      },

      columnValueList (val) {
        return this.stats.items.map(d => d[val])
      }
    },
  }
</script>
